import React, { useState } from "react";
import DefaultButton from "@/components/buttons";
import { useStyle } from "@/context/StyleContext";
import { useLanguageContext } from "@/context/LanguageContext";
import { Close } from "@mui/icons-material";
import { IconButton, Modal, Fade } from "@mui/material";

interface AnnouncementProps {
  startDate: string;
  endDate: string;
}

const Announcement: React.FC<AnnouncementProps> = ({ startDate, endDate }) => {
  const [dismissed, setDismissed] = useState(false);
  const { colors, theme } = useStyle();
  const { lang } = useLanguageContext();

  const PROMO_BASE = "https://hhrwwwphotos.blob.core.windows.net/wwwphotos";
  const promoImage =
    lang.locale === "es"
      ? `${PROMO_BASE}/hhr_july26_promo_es.jpeg`
      : `${PROMO_BASE}/hhr_july26_promo.jpeg`;

  const now = new Date();
  const start = new Date(startDate);
  const end = new Date(endDate);
  end.setHours(23, 59, 59, 999);

  if (dismissed || now < start || now > end) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <Modal
      open
      onClose={handleDismiss}
      closeAfterTransition
      slotProps={{
        backdrop: {
          sx: { backgroundColor: "rgba(0,0,0,0.6)" },
        },
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "16px",
      }}
    >
      <Fade in>
        <div
          style={{
            maxWidth: "700px",
            width: "100%",
            maxHeight: "calc(100vh - 32px)",
            overflowY: "auto",
            padding: "24px 20px",
            borderRadius: "16px",
            backgroundColor: colors[theme].background,
            border: `1px solid ${colors[theme].border}`,
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            outline: "none",
            position: "relative",
          }}
        >
          <IconButton
            onClick={handleDismiss}
            size="small"
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: colors[theme].text,
            }}
            aria-label="Close announcement"
          >
            <Close fontSize="small" />
          </IconButton>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginBottom: "24px",
            }}
          >
            <a
              href={promoImage}
              target="_blank"
              rel="noopener noreferrer"
              style={{ display: "flex", cursor: "pointer" }}
            >
              <img
                src={promoImage}
                alt={lang.t("landing.announcement.title")}
                style={{
                  width: "100%",
                  maxWidth: "420px",
                  maxHeight: "70vh",
                  borderRadius: "12px",
                  objectFit: "contain",
                }}
              />
            </a>
          </div>

          <div style={{ display: "flex", justifyContent: "center" }}>
            <DefaultButton
              onClick={() => {
                handleDismiss();
                document
                  .getElementById("section-book-now")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              {lang.t("landing.announcement.cta")}
            </DefaultButton>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default Announcement;
